import React, { Component } from 'react';
import { NumericFormat } from 'react-number-format';
import colores from '../../../css/bootstrap.scss'
import '../../../css/ingresos.css';
import toast, { Toaster } from 'react-hot-toast';
import { MyContext } from '../../../context/AuthContext';
import { Modal } from 'react-bootstrap';
import { MoonLoader } from 'react-spinners';

class CostoVenta extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            tiposCostoVenta: [],
            cuentas: [],
            sucursales: [],
            listaCostosVenta: [],
            registroPrevio: false,
            costoVentaRegistro: {
                idTipoCostoVenta: '',
                nombreTipoCostoVenta: '',
                idCuenta: '',
                nombreCuenta: '',
                monto: '',
                idSucursal: '',
                nombreSucursal: '',
                descripcion: ''
            },
            idTipoCostoVentaEditar: '',
            idCuentaEditar: '',
            idSucursalEditar: '',
            descripcionEditar: '',
            showModalEditar: false,
            dataCorte: []
         }
    }
    
    static contextType = MyContext;
   
    componentDidMount = async () => {
        this.context.cambiarSubruta('Costos de Venta');
        window.addEventListener('resize', this.getHeightWindow);
        window.addEventListener('beforeunload', this.alertUser);
        this.getHeightWindow();
        await this.selectTiposCostoVenta();
        await this.selectCuentas();
        await this.selectSucursales();
        this.comprobrarRegistros();
        this.selectDatosCorte();
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.fecha !== this.props.fecha) {
            if (this.context.rootState.saved) { 
                this.setState({
                    loading: true
                });
                this.componentDidMount();
            }else{
                if (window.confirm('¿Continuar sin guardar cambios?')) {     
                    this.setState({
                        loading: true
                    });   
                    this.componentDidMount();
                }
            }
        }
    }

    alertUser = (e) => {
        if (this.context.rootState.saved === false) {   
            e.preventDefault();
            e.returnValue = '';   
        }
    }

    getHeightWindow = () => {
        var height = window.innerHeight;
        if (document.getElementsByClassName("contenedorSecundario")[0]) {
            document.getElementsByClassName("contenedorSecundario")[0].style.height = (height - 230) + 'px';
        }
    }

    numberWithCommas = (x) => {
        x = Number(x).toFixed(2);
        if (x === 0) {
            return '0.00';
        }else{
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }

    selectTiposCostoVenta = async () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'select', empresa: this.context.rootState.nombre })
        };
        const response = await fetch('http://pruebas.argeos.net/php/DB/tiposcostoventa.php', requestOptions);
        const data = await response.json();
        this.setState({
            tiposCostoVenta: data.tiposCostoVenta
        })
    }
    
    selectCuentas = async () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'select', empresa: this.context.rootState.nombre })
        };
        const response = await fetch('http://pruebas.argeos.net/php/DB/cuentas.php', requestOptions);
        const data = await response.json();
        data.cuentas.forEach((_, index) => {
            data.cuentas[index].monto = '';
        });
        this.setState({
            cuentas: data.cuentas
        })
    }

    selectSucursales = async () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'select', empresa: this.context.rootState.nombre })
        };
        const response = await fetch('http://pruebas.argeos.net/php/DB/sucursales.php', requestOptions);
        const data = await response.json();
        data.sucursales.forEach((_, index) => {
            data.sucursales[index].monto = '';
        });
        if (data.sucursales.length === 1) { 
            this.setState({
                sucursales: data.sucursales,
                costoVentaRegistro: {
                    idTipoCostoVenta: '',
                    nombreTipoCostoVenta: '',
                    idCuenta: '',
                    nombreCuenta: '',
                    monto: '',
                    idSucursal: 1,
                    nombreSucursal: data.sucursales[0].nombre,
                    descripcion: ''
                },
            })
        }else{
            this.setState({
                sucursales: data.sucursales,
            })
        }
    }

    comprobrarRegistros = async () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'comprobar', fecha: this.props.fecha, empresa: this.context.rootState.nombre })
        };
        const response = await fetch('http://pruebas.argeos.net/php/DB/costosventa.php', requestOptions);
        const data = await response.json();
        if (data.error === 0) {
            if (data.mensaje !== false) {
                toast.success('Registro encontrado.');
                data.listaCostosVenta.forEach(element => {  
                    if (element.idCuenta !== 'efectivo') {
                        element.nombreCuenta = this.state.cuentas.find(e => e.idCuenta === element.idCuenta).nombre;
                    }else{
                        element.nombreCuenta = 'Efectivo del Día';
                    }
                    element.nombreTipoCostoVenta = this.state.tiposCostoVenta.find(e => e.idTipoCostoVenta === element.idTipoCostoVenta).nombre;
                    element.nombreSucursal = this.state.sucursales.find(e => e.idSucursal === element.idSucursal).nombre;
                });
                this.setState({
                    listaCostosVenta: data.listaCostosVenta,
                    registroPrevio: true,
                    loading: false
                })
            }else{
                this.setState({
                    registroPrevio: false,
                    listaCostosVenta: [],
                    loading: false
                })
                this.selectTiposCostoVenta();
                this.selectCuentas();
                this.selectSucursales();
            }
        }else{
            toast.error('Error al consultar registros.');
        }
    }
    
    onChangeMonto = (value) => {
        this.setState({
            ...this.state,
            costoVentaRegistro: {
                ...this.state.costoVentaRegistro,
                monto: value
            }
        })
    }

    onChangeTipoCostoVenta = (e) => {
        let nombreTipoCostoVenta = '';
        if (e.target.value) {       
            nombreTipoCostoVenta = this.state.tiposCostoVenta.find((element) => element.idTipoCostoVenta === e.target.value).nombre;   
        }
        this.setState({
            ...this.state,
            costoVentaRegistro: {
                ...this.state.costoVentaRegistro,
                idTipoCostoVenta: e.target.value,
                nombreTipoCostoVenta: nombreTipoCostoVenta
            }
        })
    }
    
    onChangeCuenta = (e) => {
        let nombreCuenta = '';
        if (e.target.value) {   
            if (e.target.value !== 'efectivo') {
                nombreCuenta = this.state.cuentas.find((element) => element.idCuenta === e.target.value).nombre;  
            }else{
                nombreCuenta = 'Efectivo del Día';
            }
        }
        this.setState({
            ...this.state,
            costoVentaRegistro: {
                ...this.state.costoVentaRegistro,
                idCuenta: e.target.value,
                nombreCuenta: nombreCuenta
            }
        })
    }

    onChangeSucursal = (e) => {
        let nombreSucursal = '';
        if (e.target.value) {       
            nombreSucursal = this.state.sucursales.find((element) => element.idSucursal === e.target.value).nombre;   
        }
        this.setState({
            ...this.state,
            costoVentaRegistro: {
                ...this.state.costoVentaRegistro,
                idSucursal: e.target.value,
                nombreSucursal: nombreSucursal
            }
        })
    }

    onChangeDescripcion = (e) => {
        this.setState({
            ...this.state,
            costoVentaRegistro: {
                ...this.state.costoVentaRegistro,
                descripcion: e.target.value,
            }
        })
    }

    agregarCostoVentaLista = () => {
        toast.remove();
        if (this.state.costoVentaRegistro.idTipoCostoVenta && this.state.costoVentaRegistro.monto && this.state.costoVentaRegistro.idCuenta && this.state.costoVentaRegistro.idSucursal) {
            if (this.state.listaCostosVenta.find(element => (element.idTipoCostoVenta === this.state.costoVentaRegistro.idTipoCostoVenta) && (element.idCuenta === this.state.costoVentaRegistro.idCuenta) && (element.idSucursal === this.state.costoVentaRegistro.idSucursal) && (element.descripcion === this.state.costoVentaRegistro.descripcion))) {
                let montoPrevio = this.state.listaCostosVenta.find(element => (element.idTipoCostoVenta === this.state.costoVentaRegistro.idTipoCostoVenta) && (element.idCuenta === this.state.costoVentaRegistro.idCuenta) && (element.idSucursal === this.state.costoVentaRegistro.idSucursal) && (element.descripcion === this.state.costoVentaRegistro.descripcion)).monto;
                let listaCostosVenta = this.state.listaCostosVenta;
                let indexProducto = this.state.listaCostosVenta.findIndex(element => (element.idTipoCostoVenta === this.state.costoVentaRegistro.idTipoCostoVenta) && (element.idCuenta === this.state.costoVentaRegistro.idCuenta) && (element.idSucursal === this.state.costoVentaRegistro.idSucursal) && (element.descripcion === this.state.costoVentaRegistro.descripcion));
                listaCostosVenta[indexProducto].monto = Number(montoPrevio) + Number(this.state.costoVentaRegistro.monto);
                if (this.state.sucursales.length === 1) {
                    this.setState({
                        listaCostosVenta: listaCostosVenta,
                        costoVentaRegistro: {
                        idTipoCostoVenta: '',
                        nombreTipoCostoVenta: '',
                        idCuenta: '',
                        nombreCuenta: '',
                        monto: '',
                        idSucursal: 1,
                        nombreSucursal: this.state.sucursales[0].nombre,
                        descripcion: ''
                        }
                    });                    
                }else{
                    this.setState({
                        listaCostosVenta: listaCostosVenta,
                        costoVentaRegistro: {
                        idTipoCostoVenta: '',
                        nombreTipoCostoVenta: '',
                        idCuenta: '',
                        nombreCuenta: '',
                        monto: '',
                        idSucursal: '',
                        nombreSucursal: '',
                        descripcion: ''
                        }
                    });
                }
                toast.success('Costo de venta sumado a la lista');    
            }else{
                if (this.state.sucursales.length === 1) {
                    this.setState(prevState => ({
                        listaCostosVenta: [...prevState.listaCostosVenta,  this.state.costoVentaRegistro],
                        costoVentaRegistro: {
                            idTipoCostoVenta: '',
                            nombreTipoCostoVenta: '',
                            idCuenta: '',
                            nombreCuenta: '',
                            monto: '',
                            idSucursal: 1,
                            nombreSucursal: this.state.sucursales[0].nombre,
                            descripcion: ''
                        }
                    }));                    
                }else{
                    this.setState(prevState => ({
                        listaCostosVenta: [...prevState.listaCostosVenta,  this.state.costoVentaRegistro],
                        costoVentaRegistro: {
                            idTipoCostoVenta: '',
                            nombreTipoCostoVenta: '',
                            idCuenta: '',
                            nombreCuenta: '',
                            monto: '',
                            idSucursal: '',
                            nombreSucursal: '',
                            descripcion: ''
                        }
                    }));                    
                }
                toast.success('Ingreso agregado a lista');
            }
            this.context.unsaveChanges();
        }else{
            toast.error('Llene los campos solicitados');
        }
    }

    editarCostoVentaLista = async () => {
        toast.remove();
        if (this.state.costoVentaRegistro.idTipoCostoVenta && this.state.costoVentaRegistro.monto && this.state.costoVentaRegistro.idCuenta && this.state.costoVentaRegistro.idSucursal) {
            let filteredArray = this.state.listaCostosVenta.filter(element => !((element.idTipoCostoVenta === this.state.idTipoCostoVentaEditar) && (element.idCuenta === this.state.idCuentaEditar) && (element.idSucursal === this.state.idSucursalEditar) && (element.descripcion === this.state.descripcionEditar)));
            await this.setState({
                listaCostosVenta: filteredArray
            });
            this.context.unsaveChanges();
            this.agregarCostoVentaLista();
            this.hideModalEditar();
        }else{
            toast.error('Llene los campos solicitados');
        }
    }

    quitarCostoVentaLista = (idTipoCostoVenta, idCuenta, idSucursal, descripcion) => {
        toast.remove();
        if (window.confirm('¿Quitar costo de venta de la lista?')) {
            let filteredArray = this.state.listaCostosVenta.filter(element => !((element.idTipoCostoVenta === idTipoCostoVenta) && (element.idCuenta === idCuenta) && (element.idSucursal === idSucursal) && (element.descripcion === descripcion)));
            this.setState({
                listaCostosVenta: filteredArray
            });
            this.context.unsaveChanges();
        }
    }

    getTotal = () => {
        let total = 0;
        let listaCostosVenta = this.state.listaCostosVenta;
        listaCostosVenta.forEach((producto) => {
            total= total += Number(producto.monto)
        });
        return total
    }

    limpiar = () => {
        if (this.state.listaCostosVenta.length !== 0) {
            if (window.confirm('¿Quitar todos los costos de la lista?')) {
                if (this.state.sucursales.length === 1) {
                    this.setState({
                        listaCostosVenta: [],
                        costoVentaRegistro: {
                            idTipoCostoVenta: '',
                            nombreTipoCostoVenta: '',
                            idCuenta: '',
                            nombreCuenta: '',
                            monto: '',
                            idSucursal: 1,
                            nombreSucursal: this.state.sucursales[0].nombre,
                            descripcion: ''
                        }
                    })                
                }else{
                    this.setState({
                        listaCostosVenta: [],
                        costoVentaRegistro: {
                            idTipoCostoVenta: '',
                            nombreTipoCostoVenta: '',
                            idCuenta: '',
                            nombreCuenta: '',
                            monto: '',
                            idSucursal: '',
                            nombreSucursal: '',
                            descripcion: ''
                        }
                    })
                }
                this.context.unsaveChanges();
            }
        }
    }

    showModalEditar = (idTipoCostoVenta, idCuenta, idSucursal, descripcion) => {
        let ingresoLista = this.state.listaCostosVenta.find(element => (element.idTipoCostoVenta === idTipoCostoVenta) && (element.idCuenta === idCuenta) && (element.idSucursal === idSucursal) && (element.descripcion === descripcion));
        this.setState({
            costoVentaRegistro: {
                idTipoCostoVenta: ingresoLista.idTipoCostoVenta,
                nombreTipoCostoVenta: ingresoLista.nombreTipoCostoVenta,
                idCuenta: ingresoLista.idCuenta,
                nombreCuenta: ingresoLista.nombreCuenta,
                monto: ingresoLista.monto,
                idSucursal: ingresoLista.idSucursal,
                nombreSucursal: ingresoLista.nombreSucursal,
                descripcion: ingresoLista.descripcion
            },
            showModalEditar: true,
            idTipoCostoVentaEditar: idTipoCostoVenta,
            idCuentaEditar: idCuenta,
            idSucursalEditar: idSucursal,
            descripcionEditar: descripcion
        });
    }

    hideModalEditar = () => {
        if (this.state.sucursales.length === 1) {                
            this.setState({
                costoVentaRegistro: {
                    idTipoCostoVenta: '',
                    nombreTipoCostoVenta: '',
                    idCuenta: '',
                    nombreCuenta: '',
                    monto: '',
                    idSucursal: 1,
                    nombreSucursal: this.state.sucursales[0].nombre,
                    descripcion: ''
                },
                showModalEditar: false,
                idTipoCostoVentaEditar: '',
                idCuentaEditar: '',
                idSucursalEditar: '',
                descripcionEditar: ''
            })
        }else{                
            this.setState({
                costoVentaRegistro: {
                    idTipoCostoVenta: '',
                    nombreTipoCostoVenta: '',
                    idCuenta: '',
                    nombreCuenta: '',
                    monto: '',
                    idSucursal: '',
                    nombreSucursal: '',
                    descripcion: ''
                },
                showModalEditar: false,
                idTipoCostoVentaEditar: '',
                idCuentaEditar: '',
                idSucursalEditar: '',
                descripcionEditar: ''
            })
        }
    }

    selectDatosCorte = async () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'selectDatosDia', fecha: this.props.fecha, empresa: this.context.rootState.nombre })
        };
        const response = await fetch('http://pruebas.argeos.net/php/DB/cortes.php', requestOptions);
        const data = await response.json();
        if (data.error === 0) {
            this.setState({
                dataCorte: data
            })
        }else{
            toast.error('Error al obtener datos de corte.');
        }
    }

    registrar = async () => {
        if (this.getTotal() !== 0) {
            this.deleteCorte();
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ operacion: 'insert', listaCostosVenta: this.state.listaCostosVenta, fecha: this.props.fecha, empresa: this.context.rootState.nombre })
            };
            const response = await fetch('http://pruebas.argeos.net/php/DB/costosventa.php', requestOptions);
            const data = await response.json();
            if (data.error === 0) {
                toast.success(data.mensaje);
                this.reloadHeader();
                this.setState({
                    registroPrevio: true
                });
                this.context.saveChanges();
            }else{
                toast.error('Error al registrar costo de venta.');
                console.log(data.mensaje);
            }
        }else{
            toast.error('No puede registrar un total de $0.');
        }
    }

    editar = async () => {
        if (this.getTotal() !== 0) {
            this.deleteCorte();
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ operacion: 'update', listaCostosVenta: this.state.listaCostosVenta, fecha: this.props.fecha, empresa: this.context.rootState.nombre })
            };
            const response = await fetch('http://pruebas.argeos.net/php/DB/costosventa.php', requestOptions);
            const data = await response.json();
            if (data.error === 0) {
                toast.success(data.mensaje);
                this.reloadHeader();
                this.setState({
                    registroPrevio: true
                });
                this.context.saveChanges();
            }else{
                toast.error('Error al editar costo de venta.');
                console.log(data.mensaje);
            }
        }else{
            if (window.confirm('¿Borrar costo de venta?')) {
                this.deleteCorte();
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ operacion: 'delete', fecha: this.props.fecha, empresa: this.context.rootState.nombre })
                };
                const response = await fetch('http://pruebas.argeos.net/php/DB/costosventa.php', requestOptions);
                const data = await response.json();
                if (data.error === 0) {
                    toast.success(data.mensaje);
                    this.reloadHeader();
                    this.setState({
                        registroPrevio: false
                    });
                    this.context.saveChanges();
                }else{
                    toast.error('Error al borrar costo de venta.');
                    console.log(data.mensaje);
                }
            }
        }
    }

    deleteCorte = async () => {
        if (this.props.estatusCorte) {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ operacion: 'deleteCorte', fecha: this.props.fecha, cuentas: this.state.dataCorte.cuentas, empresa: this.context.rootState.nombre })
            };
            const response = await fetch('http://pruebas.argeos.net/php/DB/cortes.php', requestOptions);
            const data = await response.json();
            if (data.error !== 0) { 
                toast.error('Error al borrar corte previo.');
                console.log(data.mensaje);
            }
        }
    }

    reloadHeader = () => {
        document.getElementById('btnHeaderReload').click();
    }

    render() { 
            return ( 
            <>
                <div className="contenedorSecundario bg-light" style={{ overflowY: 'auto' }}>
                    <div className="row w-100 m-0">
                        <div className="col-12">
                            <div className="elemento py-2">
                                <div className="row">
                                    <div className="col-7">
                                        <label>Tipo Costo Venta</label>
                                        <select className='form-control' name="idTipoCostoVenta" value={this.state.costoVentaRegistro.idTipoCostoVenta} onChange={this.onChangeTipoCostoVenta}>
                                            <option value="">Seleccionar</option>
                                            {
                                                this.state.tiposCostoVenta.map((e, index) =>
                                                    <option key={index} value={e.idTipoCostoVenta}>{e.nombre}</option>
                                                )
                                            }
                                        </select>
                                    </div>                                  
                                    <div className="col-5">
                                        <label>Monto</label>
                                        <div className="input-group">
                                            <span className='input-group-text'>$</span>
                                            <NumericFormat thousandSeparator=',' className='form-control text-end' required value={this.state.costoVentaRegistro.monto} defaultValue={''} placeholder='0.0' onValueChange={(values) => this.onChangeMonto(Number(values.value))}/>
                                        </div>
                                    </div>
                                    <div className="col-6 mt-2">
                                        <label>Pagado con</label>
                                        <select className='form-control' name="idCuenta" value={this.state.costoVentaRegistro.idCuenta} onChange={this.onChangeCuenta}>
                                            <option value="">Seleccionar</option>
                                            <option value="efectivo">Efectivo del Día</option>
                                            {
                                                this.state.cuentas.map((e, index) =>
                                                    <option key={index} value={e.idCuenta}>{e.nombre}</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                    <div className="col-6 mt-2">
                                        <label>Sucursal</label>
                                        <select className='form-control' name="idSucursal" value={this.state.costoVentaRegistro.idSucursal} onChange={this.onChangeSucursal} disabled={this.state.sucursales.length === 1}>
                                            <option value="">Seleccionar</option>
                                            {
                                                this.state.sucursales.map((e, index) =>
                                                    <option key={index} value={e.idSucursal} hidden={e.cerrado}>{e.nombre}</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                    <div className="col-12 mt-2">
                                        <label>Descripción</label>
                                        <input type="text" className='form-control' name='descripcion' value={this.state.costoVentaRegistro.descripcion} onChange={this.onChangeDescripcion}/>
                                    </div>
                                    <div className="col-12 mt-2 d-flex align-items-end justify-content-center">
                                        <button className='btn btn-info btnRadius px-4' style={{ color: 'white' }} onClick={this.agregarCostoVentaLista}>Agregar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.listaCostosVenta[0] ?
                                this.state.listaCostosVenta.map((e, index) =>
                                    <div className="col-12 mt-3" key={index}>
                                        <div className="elemento py-1">
                                            <div className="row">
                                                <div className="col-8">
                                                    <div className="row">
                                                        <div className="col-12 d-flex">
                                                            <p className='m-0' style={{ fontSize: '12px' }}>{e.nombreSucursal + ' ->'}</p><p className='m-0 ms-1' style={{ fontSize: '12px' }}>{e.nombreTipoCostoVenta}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <p className='m-0' style={{ fontSize: '10px' }}><i className="bi bi-credit-card"></i> {e.nombreCuenta}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <p className='m-0' style={{ fontSize: '10px' }}>{e.descripcion}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-4" style={{ borderLeft: '1px solid #e0e0e0' }}>
                                                    <div className="row" style={{ borderBottom: '1px solid #e0e0e0' }}>
                                                        <div className="col-12 text-end">
                                                            <p className='m-0' style={{ fontSize: '14px' }}>$ {this.numberWithCommas(e.monto)}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-6 p-0 text-center">
                                                            <button className='btn btn-sm btn-outline-secondary me-1 ms-auto py-0 px-2 w-75' style={{ height: '20px' }} onClick={() => this.showModalEditar(e.idTipoCostoVenta, e.idCuenta, e.idSucursal, e.descripcion)}>
                                                                <i className="bi bi-pen" style={{ color: colores.secondary, fontSize: '12px' }}></i>
                                                            </button>
                                                        </div>
                                                        <div className="col-6 p-0 text-center">
                                                            <button className='btn btn-sm btn-outline-danger ms-1 me-auto py-0 px-2 w-75' style={{ height: '20px' }} onClick={() => this.quitarCostoVentaLista(e.idTipoCostoVenta, e.idCuenta, e.idSucursal, e.descripcion)}>
                                                                <i className="bi bi-trash" style={{ color: colores.danger, fontSize: '12px' }}></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            :
                                <div className="col-12 mt-3">
                                    <div className="elemento text-center">
                                        <p className='m-0'>Agregue elementos a la lista</p>
                                    </div>
                                </div>
                        }
                    </div>
                </div>
                <div className="contenedorSecundarioTotal bg-white">
                    <div className="row m-0 h-100">
                        <div className="col-6" style={{ borderRight: '1px solid ' + colores.light, color: 'black', paddingBlock: '10px' }}>
                            Total Costo de Venta:
                        </div>
                        <div className="col-6 text-end" style={{ color: 'black', paddingBlock: '10px' }}>
                            $ {this.numberWithCommas(this.getTotal())}
                        </div>
                        <div className="col-12 text-center d-flex align-items-center py-2 justify-content-center" style={{ borderTop: '1px solid ' + colores.light }}>
                            <button className='btn btn-lg btn-primary btnRadius mx-3' style={{ width: '40%', color: 'white' }} onClick={this.limpiar}>Limpiar</button>
                            {
                                this.state.registroPrevio ?
                                    <button className='btn btn-lg btn-secondary text-white btnRadius mx-3' style={{ width: '40%' }} onClick={this.editar}>Editar</button>
                                :
                                    <button className='btn btn-lg btn-secondary text-white btnRadius mx-3' style={{ width: '40%' }} onClick={this.registrar}>Registrar</button>
                            }
                        </div>
                    </div>
                </div>
                <Modal show={this.state.showModalEditar} onHide={this.hideModalEditar} centered>
                    <Modal.Header className='degradado'>                        
                        <h5 style={{ color: 'white' }} className='m-0'>Editar Costo de Venta</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-7">
                                <label>Tipo Costo Venta</label>
                                <select className='form-control' name="idTipoCostoVenta" style={{ color: 'black' }} value={this.state.costoVentaRegistro.idTipoCostoVenta} onChange={this.onChangeTipoCostoVenta}>
                                    <option value="">Seleccionar</option>
                                    {
                                        this.state.tiposCostoVenta.map((e, index) =>
                                            <option key={index} value={e.idTipoCostoVenta}>{e.nombre}</option>
                                        )
                                    }
                                </select>
                            </div>                                  
                            <div className="col-5">
                                <label>Monto</label>
                                <div className="input-group">
                                    <span className='input-group-text'>$</span>
                                    <NumericFormat thousandSeparator=',' className='form-control text-end' style={{ color: 'black' }} required value={this.state.costoVentaRegistro.monto} defaultValue={''} placeholder='0.0' onValueChange={(values) => this.onChangeMonto(Number(values.value))}/>
                                </div>
                            </div>
                            <div className="col-6 mt-2">
                                <label>Pagado con</label>
                                <select className='form-control' name="idCuenta" style={{ color: 'black' }} value={this.state.costoVentaRegistro.idCuenta} onChange={this.onChangeCuenta}>
                                    <option value="">Seleccionar</option>
                                    <option value="efectivo">Efectivo del Día</option>
                                    {
                                        this.state.cuentas.map((e, index) =>
                                            <option key={index} value={e.idCuenta}>{e.nombre}</option>
                                        )
                                    }
                                </select>
                            </div>
                            <div className="col-6 mt-2">
                                <label>Sucursal</label>
                                <select className='form-control' name="idSucursal" style={{ color: 'black' }} value={this.state.costoVentaRegistro.idSucursal} onChange={this.onChangeSucursal} disabled={this.state.sucursales.length === 1}>
                                    <option value="">Seleccionar</option>
                                    {
                                        this.state.sucursales.map((e, index) =>
                                            <option key={index} value={e.idSucursal} hidden={e.cerrado}>{e.nombre}</option>
                                        )
                                    }
                                </select>
                            </div>
                            <div className="col-12 mt-2">
                                <label>Descripción</label>
                                <input type="text" className='form-control' name='descripcion' style={{ color: 'black' }} value={this.state.costoVentaRegistro.descripcion} onChange={this.onChangeDescripcion}/>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className='btn btnRadius btn-primary text-white mx-3' style={{ width: '30%' }} type='button' onClick={this.hideModalEditar}>Cancelar</button>
                        <button className='btn btnRadius btn-secondary mx-3' style={{ width: '30%', color: 'white' }} type='button' onClick={this.editarCostoVentaLista}>Editar</button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.loading} centered size='sm' className='modalCargando'>
                    <Modal.Body className='ms-auto me-auto'>
                        <MoonLoader color={'#ffffff'} loading={true} size={100} />
                    </Modal.Body>
                </Modal>
                <Toaster/>
            </>
                )
    }
}
 
export default CostoVenta;